import Cookies from "js-cookie";
export function deleteAllCookies() {
  Cookies.remove('refreshToken')
  Cookies.remove('token')
  Cookies.remove('vue_admin_template_token')
  Cookies.remove('ispc')
}
